import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import freefitLogo from "../../../img/FREEFIT_LOGO_new.png";
import mastercardLogo from "../../../img/svg/Mastercard_new.svg";
import ScreenHeader from "../../components/ScreenHeader";
import "./passPurchase.scss";

// Chevron pointing to the inline-end (left in RTL).
const ChevronEnd = () => (
  <svg className="pp-v2-chevron" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 3L5 8L10 13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CardIcon = () => (
  <svg className="pp-v2-pay-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="5" width="20" height="14" rx="3" stroke="currentColor" strokeWidth="1.8" />
    <path d="M2 10H22" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

// V2 multi-entry pass purchase (/multipleEntryPassPurchase) — presentational.
// Purchase logic stays in the V1 screens/multipleEntryPassPurchase.jsx.
// hasCard: null = card status still loading (row hidden), true = tappable card row
// (-> card details), false = tappable "add credit card" row (-> add card).
function PassPurchase({
  passImg,
  title,
  subtitle,
  expiresText,
  showCardRow,
  hasCard,
  last4Digit,
  total,
  onPay,
  onPaymentRowClick,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="pp-v2">
      <ScreenHeader title={t("PURCHASE_SUMMARY")} onBack={() => navigate(-1)} />

      <div className="pp-v2-content">
        <img className="pp-v2-logo" src={freefitLogo} alt="freefit" />

        <img className="pp-v2-art" src={passImg} alt="" />

        <div className="pp-v2-divider" />

        <p className="pp-v2-title">{title}</p>
        <p className="pp-v2-subtitle">{subtitle}</p>
        <p className="pp-v2-subtitle">{expiresText}</p>

        {showCardRow && hasCard === true && (
          <button type="button" className="pp-v2-pay-row pp-v2-pay-row--tappable" onClick={onPaymentRowClick}>
            <span className="pp-v2-radio" aria-hidden="true" />
            <p className="pp-v2-pay-label">{t("CREDIT_CARD")}</p>
            <span className="pp-v2-pay-spacer" />
            <p className="pp-v2-card-digits">•••• {last4Digit}</p>
            <img className="pp-v2-mastercard" src={mastercardLogo} alt="" />
            <ChevronEnd />
          </button>
        )}

        {showCardRow && hasCard === false && (
          <button type="button" className="pp-v2-pay-row pp-v2-pay-row--tappable" onClick={onPaymentRowClick}>
            <CardIcon />
            <div className="pp-v2-pay-texts">
              <p className="pp-v2-pay-title">{t("PAYMENT_METHOD")}</p>
              <p className="pp-v2-pay-subtitle">{t("ADD_CREDIT_CARD_SUBTITLE")}</p>
            </div>
            <span className="pp-v2-pay-spacer" />
            <ChevronEnd />
          </button>
        )}
      </div>

      <p className="pp-v2-total">
        {t("TOTAL_PRICE")}: ₪{total}
      </p>

      <div className="pp-v2-bottom-bar">
        <button type="button" className="pp-v2-cta" onClick={onPay}>
          {t("PAYMENT")}
        </button>
      </div>
    </div>
  );
}

export default PassPurchase;
